import BaseAPI from './base'
/**
 * API xử lý lớp học
 */
class LessonNoteAPI extends BaseAPI {}

export default new LessonNoteAPI('v1/lesson-note', 'LessonNote')
